export var GridFlexDirection;
(function (GridFlexDirection) {
    GridFlexDirection["ROW"] = "row";
    GridFlexDirection["COLUMN"] = "column";
})(GridFlexDirection || (GridFlexDirection = {}));
export var GridItemTypeTokens;
(function (GridItemTypeTokens) {
    GridItemTypeTokens["HORIZONTAl"] = "horizontal";
    GridItemTypeTokens["VERITICAL"] = "vertical";
    GridItemTypeTokens["HORIZONTAl_VERITICAL"] = "horizontal_vertical";
    GridItemTypeTokens["IFRAME"] = "iFrame";
    GridItemTypeTokens["DASHBOARD_ITEM"] = "DASHBOARD_ITEM";
})(GridItemTypeTokens || (GridItemTypeTokens = {}));
